import { MixinMethodMode } from "./types.js";

const applyMixinOverrides = (target: any, source: any) => {
  // Loop through all properties of the source class
  Object.getOwnPropertyNames(source.prototype).forEach((name) => {
    if (name === "constructor") return; // Skip the constructor
    if (Object.prototype.hasOwnProperty.call(target, name)) return;

    const sourceDescriptor = Object.getOwnPropertyDescriptor(source.prototype, name);
    if (!sourceDescriptor) return; // Skip if no descriptor found

    const targetPrototype = Object.getPrototypeOf(target);
    const targetDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, name);

    // If the target doesn't have this method, just copy the source's descriptor.
    if (!targetDescriptor) {
      Object.defineProperty(target, name, sourceDescriptor);
    }
  });
}
const applyMixinExtends = (target: any, source: any) => {
  // Loop through all properties of the source class
  Object.getOwnPropertyNames(source.prototype).forEach((name) => {
    if (name === "constructor") {
      return;
    }
    if (Object.prototype.hasOwnProperty.call(target, name)) return;

    const sourceDescriptor = Object.getOwnPropertyDescriptor(source.prototype, name);
    if (!sourceDescriptor) return; // Skip if no descriptor found

    const targetPrototype = Object.getPrototypeOf(target);
    const targetDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, name);

    // If both are functions, wrap them so source's method is called first,
    // then the target's original.
    if (
      targetDescriptor &&
      typeof targetDescriptor.value === "function" &&
      typeof sourceDescriptor.value === "function"
    ) {
      const originalTargetMethod = targetDescriptor.value;
      const sourceMethod = sourceDescriptor.value;
      Object.defineProperty(target, name, {
        value: function (...args: any[]) {
          // Call the source's method first.
          sourceMethod.apply(this, args);
          // Then call the target's original method.
          return originalTargetMethod.apply(this, args);
        },
        writable: true,
        configurable: true,
      });
    } else {
      // If the target doesn't have this method, just copy the source's descriptor.
      Object.defineProperty(target, name, sourceDescriptor);
    }
  });
}

/**
 * Apply a mixin system class to a target system instance.
 */
export const applySystemMixin = (target: any, source: any, source_args: any, mixinMethodMode: MixinMethodMode) => {
  if(source.prototype.constructor) {
    // first construct the original class to get the default values
    const constructed = new source(source_args);
    if(!constructed.name) {
      throw new Error(`Shared System: ${source.name} does not have a name property, make sure to call super in the constructor with a name param.`);
    }
    if(target.name && target.name !== constructed.name) {
      throw new Error(`Shared System: ${source.name} name property does not match the target name property, make sure to call super in the constructor with a name param in the shared class, and make sure you dont call it in the inheritted class or make sure you call it with the same name in the inheritted class.`);
    }
    target.name = constructed.name;

    const constructedDescriptors = Object.getOwnPropertyDescriptors(constructed);
    Object.keys(constructedDescriptors).forEach((key) => {
      if (key === 'name') return;
      const descriptor = constructedDescriptors[key];
      if (!descriptor) return;
      const value = descriptor.value;
      const isFunctionValue = typeof value === 'function';
      if (isFunctionValue) {
        Object.defineProperty(target, key, descriptor);
        return;
      }
      if (!(key in target)) {
        Object.defineProperty(target, key, descriptor);
      }
    });
  }
  
  if(mixinMethodMode === MixinMethodMode.EXTEND) {
    applyMixinExtends(target, source);
  } else {
    applyMixinOverrides(target, source);
  }
}